import React, { useState } from 'react';
import { Card, Table, Tag, Button, Modal, Select, Space, message, Descriptions, Empty } from 'antd';
import { FileTextOutlined, PlusOutlined, DeleteOutlined, EyeOutlined, SyncOutlined } from '@ant-design/icons';
import dayjs from 'dayjs';
import { useListReportesQuery, useDeleteReporteMutation, useGenerarReporteMensualMutation, useGenerarReportesRecomendadosMutation, useListProjectsQuery } from '../store/api';
import { reportesApi } from '../store/api';

const { Option } = Select;

const Reportes = () => {
  const { data = [], isLoading, refetch } = useListReportesQuery();
  const { data: projects = [] } = useListProjectsQuery();
  const [viewReporte] = reportesApi.useLazyViewReporteQuery();
  const [deleteReporte] = useDeleteReporteMutation();
  const [generar, { isLoading: generating }] = useGenerarReporteMensualMutation();
  const [generarRecomendados, { isLoading: generatingRec }] = useGenerarReportesRecomendadosMutation();
  const [detailModal, setDetailModal] = useState(false);
  const [detail, setDetail] = useState(null);
  const [genModal, setGenModal] = useState(false);
  const [genProject, setGenProject] = useState(null);

  const handleGenerar = async () => {
    try {
      await generar({ proyecto_id: genProject }).unwrap();
      message.success('Reporte generado'); setGenModal(false); refetch();
    } catch { message.error('Error al generar reporte'); }
  };

  const handleView = async (id) => {
    try {
      const res = await viewReporte(id).unwrap();
      setDetail(res);
      setDetailModal(true);
    } catch { message.error('Error al obtener reporte'); }
  };

  const tipoColors = { mensual: 'blue', semanal: 'green', incidente: 'red' };
  const columns = [
    { title: 'ID', dataIndex: 'id', width: 50 },
    { title: 'Título', dataIndex: 'titulo', ellipsis: true },
    { title: 'Proyecto', dataIndex: 'proyecto_nombre', render: n => n || <span style={{ color: '#bbb' }}>General</span> },
    { title: 'Período', dataIndex: 'periodo', width: 110 },
    { title: 'Tipo', dataIndex: 'tipo', width: 100, render: t => <Tag color={tipoColors[t] || 'default'}>{t}</Tag>,
      filters: [{text:'Mensual',value:'mensual'},{text:'Semanal',value:'semanal'},{text:'Incidente',value:'incidente'}], onFilter: (v,r) => r.tipo === v },
    { title: 'Generado', dataIndex: 'created_at', width: 140, render: d => d ? dayjs(d).format('DD/MM/YYYY HH:mm') : '-' },
    { title: '', key: 'act', width: 100, render: (_, r) => (
      <Space size={4}>
        <Button size="small" icon={<EyeOutlined />} onClick={() => handleView(r.id)}>Ver</Button>
        <Button size="small" danger icon={<DeleteOutlined />} onClick={() => Modal.confirm({
          title: '¿Eliminar?', onOk: async () => { await deleteReporte(r.id).unwrap(); refetch(); }
        })} />
      </Space>
    )},
  ];

  const renderDatos = (datos) => {
    if (!datos) return <Empty />;
    let parsed = datos;
    if (typeof datos === 'string') { try { parsed = JSON.parse(datos); } catch { return <pre style={{ fontSize: 12 }}>{datos}</pre>; } }
    return (
      <Descriptions size="small" column={2} bordered>
        {Object.entries(parsed).map(([key, val]) => (
          <Descriptions.Item key={key} label={key} span={typeof val === 'object' ? 2 : 1}>
            {typeof val === 'object' ? <pre style={{ fontSize: 11, margin: 0 }}>{JSON.stringify(val, null, 2)}</pre> : String(val)}
          </Descriptions.Item>
        ))}
      </Descriptions>
    );
  };

  return (
    <div className="page-container fade-in">
      <div className="page-header">
        <div className="page-header-left">
          <h1 className="page-title"><FileTextOutlined style={{ marginRight: 8 }} />Reportes</h1>
          <div className="page-subtitle">{data.length} reportes generados</div>
        </div>
        <Space>
          <Button type="primary" icon={<PlusOutlined />} onClick={() => { setGenProject(null); setGenModal(true); }}>Generar Reporte</Button>
          <Button icon={<SyncOutlined />} loading={generatingRec} onClick={async () => {
            try { const r = await generarRecomendados().unwrap(); message.success(r.message || `${r.reportes_generados} reportes generados`); refetch(); }
            catch { message.error('Error al generar reportes recomendados'); }
          }}>Generar Recomendados</Button>
        </Space>
      </div>

      <Card bordered={false} bodyStyle={{ padding: 0 }}>
        <Table columns={columns} dataSource={data} rowKey="id" loading={isLoading} pagination={{ pageSize: 10 }} size="middle" scroll={{ x: true }} />
      </Card>

      <Modal title="Generar Reporte Mensual" open={genModal} onOk={handleGenerar} confirmLoading={generating}
        onCancel={() => setGenModal(false)} okText="Generar" okButtonProps={{ icon: <SyncOutlined /> }}>
        <p>Selecciona un proyecto para generar el reporte del mes actual:</p>
        <Select style={{ width: '100%' }} value={genProject} onChange={setGenProject} placeholder="Seleccionar proyecto">
          {projects.map(p => <Option key={p.id} value={p.id}>{p.nombre}</Option>)}
        </Select>
      </Modal>

      <Modal title={detail?.titulo || 'Reporte'}
        open={detailModal} onCancel={() => setDetailModal(false)} footer={null} width={700}>
        {detail && renderDatos(detail.contenido)}
      </Modal>
    </div>
  );
};

export default Reportes;
